import React from 'react';
import styled from 'styled-components';

const P = styled.p`
  display: ${({ show }) => (show ? 'block' : 'none')};
  margin: 0.5rem 0 0;
  padding: 0.75rem 0.9rem;
  border-radius: 0.75rem;
  color: ${({ error }) => (error ? '#812525' : '#155b36')};
  background: ${({ error }) => (error ? '#fdecec' : '#e9f7ef')};
  font-size: 0.86rem;
  font-weight: 700;
  text-align: left;
`;

function Message({ children, error, success, show }) {
  return (
    <P error={error || !success} show={show} role={error ? 'alert' : 'status'}>
      {children}
    </P>
  );
}

export default Message;
